import React from 'react';
import { Button, Result } from 'antd';
import type { FallbackProps } from 'react-error-boundary';

export default function GlobalErrorFallback({ resetErrorBoundary, }: FallbackProps) {
	return (
		<div style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			minHeight: '100vh',
			backgroundColor: '#f5f5f5',
		}}
		>
			<Result
				status="error"
				title="Ocorreu um erro inesperado"
				subTitle="Algo deu errado. Tente recarregar a página."
				extra={[
					<Button
						key="reload"
						type="primary"
						onClick={() => {
							resetErrorBoundary();
							window.location.reload();
						}}
					>
						Recarregar página
					</Button>,
				]}
			/>
		</div>
	);
}
